import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Switch the session into a company, drop cached screens from the previous one, then open `to`.
export async function switchCompany(id, to = "/pipeline") {
  await api.put("/me/company", { company_id: id });
  const path = sessionStorage.getItem("company_path");
  sessionStorage.clear();
  if (path) sessionStorage.setItem("company_path", path);
  window.location.assign(to);
}

// Shown only when the signed-in admin can reach more than one company; switching reloads every screen in that company.
export function CompanySwitcher() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/companies").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || d.companies.length < 2) return null;
  const pick = async (id) => {
    try { await switchCompany(id); } catch (e) { toast.error(e?.response?.data?.detail || "Could not switch company"); }
  };
  return (
    <label className="block px-2 mb-4">
      <span className="block text-[10px] uppercase tracking-[0.2em] text-white/60 mb-1">Company</span>
      <select data-testid="company-switcher" value={d.active || ""} onChange={(e) => pick(e.target.value)}
        className="w-full h-9 rounded-lg bg-white/10 text-white text-sm px-2 border border-white/20">
        {d.companies.map((c) => <option key={c.id} value={c.id} className="text-black">{c.name}{c.active ? "" : " (inactive)"}</option>)}
      </select>
    </label>
  );
}
